import { Injectable } from '@angular/core';
import { TreeSelectModel } from '@hrra/common-models';
import { ApiResponse, CachingHttpService, SmartHttpService, UrlConfigService } from '@hrra/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UrlConfigContainer } from 'src/app/core/url-config';

@Injectable({
  providedIn: 'root'
})
export class IndustryPublicService {

  getTreeSelectIndustries(): Observable<ApiResponse<TreeSelectModel<string>[], {}>> {  
    return this.cachingHttp.get<TreeSelectModel<string>[]>(this.urlService.urlConfig.api.data.industry.getIndustryTree, {}).pipe(
      map(d =>{
        return JSON.parse(JSON.stringify(d))
      }
    ));    
  }

  constructor(private urlService: UrlConfigService<UrlConfigContainer>, private smartHttp: SmartHttpService, private cachingHttp: CachingHttpService){}

}
